import { ReqType, ResType, UrlPaths } from "@fanka/openapi-typescript";
import { appApiClient } from "@on-site/libs/appApiClient";
import { AppApiSwrMutateOptions } from "@on-site/libs/swr/type";
import { Key } from "swr";
import useSWRMutation from "swr/mutation";

export const useAppApiSWRPost = <TEndpoint extends UrlPaths>(
  endpoint: TEndpoint,
  options?: AppApiSwrMutateOptions<TEndpoint, "post">,
) =>
  useSWRMutation<ResType<TEndpoint, "post">, Error, Key, ReqType<TEndpoint, "post">, ResType<TEndpoint, "post">>(
    endpoint,
    async (path: TEndpoint, { arg }: { arg: ReqType<TEndpoint, "post"> }) =>
      (await appApiClient.post(path, arg, options)).data,
    options,
  );

export const useAppApiSWRPut = <TEndpoint extends UrlPaths>(
  endpoint: TEndpoint,
  options?: AppApiSwrMutateOptions<TEndpoint, "put">,
) =>
  useSWRMutation<ResType<TEndpoint, "put">, Error, Key, ReqType<TEndpoint, "put">, ResType<TEndpoint, "put">>(
    endpoint,
    async (path: TEndpoint, { arg }: { arg: ReqType<TEndpoint, "put"> }) =>
      (await appApiClient.put(path, arg, options)).data,
    options,
  );

export const useAppApiSWRDelete = <TEndpoint extends UrlPaths>(
  endpoint: TEndpoint,
  options?: AppApiSwrMutateOptions<TEndpoint, "delete">,
) =>
  useSWRMutation<ResType<TEndpoint, "delete">, Error, Key, ReqType<TEndpoint, "delete">, ResType<TEndpoint, "delete">>(
    endpoint,
    async (path: TEndpoint, { arg }: { arg: ReqType<TEndpoint, "delete"> }) =>
      (await appApiClient.destroy(path, arg, options)).data,
    options,
  );
